import { ToggleButton } from "@fluentui/react-components";
import { useState } from "react";
import { CheckboxChecked24Regular, CheckboxUnchecked24Regular } from "@fluentui/react-icons";

interface ToggleButtonGroupProps {
    keys: string[];
    checkedIndex?: number;
    action: (x: string) => void;
}

export const ToggleButtonGroup = (props: ToggleButtonGroupProps) => {
    const initialButtonStates = props.keys.map((key, index) => [key, index === props.checkedIndex] as [string, boolean]);
    const [buttonStates, setButtonStates] = useState<[string, boolean][]>(initialButtonStates);

    function onToggle(key: string) {
        setButtonStates(buttonStates.map((x) => x[0] === key ? [x[0], true] : [x[0], false]));
        props.action(key);
    }

    return <div className="flex flex-row space-x-2">
        {buttonStates.map((key) => <ToggleButton icon={key[1] ? <CheckboxChecked24Regular /> : <CheckboxUnchecked24Regular />} checked={key[1]} key={key[0]} onClick={() => onToggle(key[0])} >{key}</ToggleButton>)}
    </div>
};